import { render, staticRenderFns } from "./KyyAppModalStudentOrder.vue?vue&type=template&id=ea815168&"
import script from "./KyyAppModalStudentOrder.vue?vue&type=script&lang=js&"
export * from "./KyyAppModalStudentOrder.vue?vue&type=script&lang=js&"
import style0 from "./KyyAppModalStudentOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports